// types.js
export const SHOW_LOADING_CIRCULAR = 'FDBK_MGMT_SHOW_LOADING_CIRCULAR';
export const SHOW_LOADING_LINEAR = 'FDBK_MGMT_SHOW_LOADING_LINEAR';
export const UPDATE_ALERT_BOX_PARAMS = 'FDBK_MGMT_UPDATE_ALERT_BOX_PARAMS';
export const HANDLE_ACTIVE_TAB = 'FDBK_MGMT_HANDLE_ACTIVE_TAB';
export const HANDLE_PUBLIC_REVIEW_RATING = 'FDBK_MGMT_HANDLE_PUBLIC_REVIEW_RATING';
export const HANDLE_TOGGLE_MORE_FILTERS = 'FDBK_MGMT_HANDLE_TOGGLE_MORE_FILTERS';
export const UPDATE_CHART_DATE_BASIC_FILTER = 'FDBK_MGMT_UPDATE_CHART_DATE_BASIC_FILTER';
export const UPDATE_CHART_DATE_ADVANCE_FILTER = 'FDBK_MGMT_UPDATE_CHART_DATE_ADVANCE_FILTER';
export const UPDATE_CHART_DATE_RESULT_DATA_FLAG = 'FDBK_MGMT_UPDATE_CHART_DATE_RESULT_DATA_FLAG';
export const UPDATE_CHART_DATE_DATA_PENDING = 'FDBK_MGMT_UPDATE_CHART_DATE_DATA_PENDING';
export const UPDATE_CHART_DATE_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_CHART_DATE_DATA_SUCCESS';
export const UPDATE_CHART_DATE_DATA_FAILED = 'FDBK_MGMT_UPDATE_CHART_DATE_DATA_FAILED';
export const UPDATE_CHART_DATE_ADVANCE_FILTER_DATA_PENDING = 'FDBK_MGMT_UPDATE_CHART_DATE_ADVANCE_FILTER_DATA_PENDING';
export const UPDATE_CHART_DATE_ADVANCE_FILTER_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_CHART_DATE_ADVANCE_FILTER_DATA_SUCCESS';
export const RESET_CHART_DATE_ADVANCE_FILTER = 'FDBK_MGMT_RESET_CHART_DATE_ADVANCE_FILTER';
export const UPDATE_FEEDBACK_DATE_BASIC_FILTER = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_BASIC_FILTER';
export const HANDLE_FEEDBACK_DATE_TOGGLE_MORE_FILTERS = 'FDBK_MGMT_HANDLE_FEEDBACK_DATE_TOGGLE_MORE_FILTERS';
export const UPDATE_FEEDBACK_DATE_ADVANCE_FILTER = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_ADVANCE_FILTER';
export const UPDATE_FEEDBACK_DATE_RESULT_DATA_FLAG = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_RESULT_DATA_FLAG';
export const UPDATE_FEEDBACK_DATE_DATA_PENDING = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_DATA_PENDING';
export const UPDATE_FEEDBACK_DATE_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_DATA_SUCCESS';
export const UPDATE_FEEDBACK_DATE_DATA_FAILED = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_DATA_FAILED';
export const UPDATE_FEEDBACK_DATE_ADVANCE_FILTER_DATA_PENDING = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_ADVANCE_FILTER_DATA_PENDING';
export const UPDATE_FEEDBACK_DATE_ADVANCE_FILTER_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_FEEDBACK_DATE_ADVANCE_FILTER_DATA_SUCCESS';
export const RESET_FEEDBACK_DATE_ADVANCE_FILTER = 'FDBK_MGMT_RESET_FEEDBACK_DATE_ADVANCE_FILTER';
export const HANDLE_DASHBOARD_COUNT_LINKS = 'FDBK_MGMT_HANDLE_DASHBOARD_COUNT_LINKS';
export const UPDATE_DASHBOARD_ACTION = 'FDBK_MGMT_UPDATE_DASHBOARD_ACTION';
export const UPDATE_DASHBOARD_DATA_PENDING = 'FDBK_MGMT_UPDATE_DASHBOARD_DATA_PENDING';
export const UPDATE_DASHBOARD_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_DASHBOARD_DATA_SUCCESS';
export const UPDATE_DASHBOARD_DATA_FAILED = 'FDBK_MGMT_UPDATE_DASHBOARD_DATA_FAILED';
export const HANDLE_FEEDBACK_CLOSED_SUCCESS = 'FDBK_MGMT_HANDLE_FEEDBACK_CLOSED_SUCCESS';
export const UPDATE_DASHBOARD_BASIC_FILTER = 'FDBK_MGMT_UPDATE_DASHBOARD_BASIC_FILTER';
export const UPDATE_DEPOT_DIVISION_DATA_PENDING = 'FDBK_MGMT_UPDATE_DEPOT_DIVISION_DATA_PENDING';
export const UPDATE_DEPOT_DIVISION_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_DEPOT_DIVISION_DATA_SUCCESS';


export const UPDATE_DEPOT_DIVISION_DATA_FAILED = 'FDBK_MGMT_UPDATE_DEPOT_DIVISION_DATA_FAILED';
export const UPDATE_SERVICE_CLASS_DATA_PENDING = 'FDBK_MGMT_UPDATE_SERVICE_CLASS_DATA_PENDING';
export const UPDATE_SERVICE_CLASS_DATA_FAILED = 'FDBK_MGMT_UPDATE_SERVICE_CLASS_DATA_FAILED';


export const UPDATE_SERVICE_CLASS_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_SERVICE_CLASS_DATA_SUCCESS';

export const UPDATE_DASHBOARD_SEARCH_PARAMS = 'FDBK_MGMT_UPDATE_DASHBOARD_SEARCH_PARAMS';
export const RESET_DASHBOARD_SEARCH_PARAMS = 'FDBK_MGMT_RESET_DASHBOARD_SEARCH_PARAMS';
export const SET_DASHBOARD_TABLE_DATA = 'FDBK_MGMT_SET_DASHBOARD_TABLE_DATA';
export const UPDATE_DASHBOARD_CHART_DATE_BASIC_FILTER = 'FDBK_MGMT_UPDATE_DASHBOARD_CHART_DATE_BASIC_FILTER';
export const UPDATE_DASHBOARD_CHART_DATE_ADVANCE_FILTER = 'FDBK_MGMT_UPDATE_DASHBOARD_CHART_DATE_ADVANCE_FILTER';
export const UPDATE_DASHBOARD_CHART_DATE_RESULT_DATA_FLAG = 'FDBK_MGMT_UPDATE_DASHBOARD_CHART_DATE_RESULT_DATA_FLAG';
export const UPDATE_DASHBOARD_CHART_DATE_DATA_PENDING = 'FDBK_MGMT_UPDATE_DASHBOARD_CHART_DATE_DATA_PENDING';
export const UPDATE_DASHBOARD_CHART_DATE_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_DASHBOARD_CHART_DATE_DATA_SUCCESS';
export const UPDATE_DASHBOARD_CHART_DATE_DATA_FAILED = 'FDBK_MGMT_UPDATE_DASHBOARD_CHART_DATE_DATA_FAILED';




//for login
export const UPDATE_LOGIN_USER_DATA_PENDING = 'FDBK_MGMT_UPDATE_LOGIN_USER_DATA_PENDING';
export const UPDATE_LOGIN_USER_DATA_SUCCESS = 'FDBK_MGMT_UPDATE_LOGIN_USER_DATA_SUCCESS';
export const UPDATE_LOGIN_USER_DATA_FAILED = 'FDBK_MGMT_UPDATE_LOGIN_USER_DATA_FAILED';
export const HANDLE_FEEDBACK_CLOSED_SUCCESS_BEFORE = 'HANDLE_FEEDBACK_CLOSED_SUCCESS_BEFORE';
export const UPDATE_FEEDBACK_PER_PAGE = 'UPDATE_FEEDBACK_PER_PAGE';